import React, { Fragment } from 'react'
import ThankYouScreen from '../../Components/ThankYou'

const ThankYou = () => {
    return (
        <Fragment >
            <ThankYouScreen />
        </Fragment>
    )
}

export default ThankYou